export type PcaField = {
  name: string;
  description?: string;
  type: "string" | "enum" | "number" | "boolean";
  required?: boolean;
  choices?: string[];
};

export type BooleanFilter = "any" | "true" | "false" | "missing";

export type FilterValue =
  | { type: "string"; value: string }
  | { type: "number"; min: string; max: string }
  | { type: "boolean"; value: BooleanFilter }
  | { type: "enum"; values: string[] };

export type FilterMap = Record<string, FilterValue>;

export const MISSING_SENTINEL = "__missing__";

export const emptyFilter = (field: PcaField): FilterValue => {
  switch (field.type) {
    case "string":
      return { type: "string", value: "" };
    case "number":
      return { type: "number", min: "", max: "" };
    case "boolean":
      return { type: "boolean", value: "any" };
    case "enum":
      return { type: "enum", values: [] };
  }
};

export const isFilterActive = (f: FilterValue): boolean => {
  switch (f.type) {
    case "string":
      return f.value.trim().length > 0;
    case "number":
      return f.min.trim().length > 0 || f.max.trim().length > 0;
    case "boolean":
      return f.value !== "any";
    case "enum":
      return f.values.length > 0;
  }
};
